import { useMemo, useCallback } from 'react';
export var useToggleAllCheckbox = function (rowsData, uxState, handleUxChange) {
    var allChecked = useMemo(function () { return rowsData && (rowsData || []).length >= 1 && rowsData.every(function (row) { var _a; return (_a = uxState === null || uxState === void 0 ? void 0 : uxState.checkedRows) === null || _a === void 0 ? void 0 : _a[row.id]; }); }, [rowsData, uxState === null || uxState === void 0 ? void 0 : uxState.checkedRows]);
    var toggleAllHandler = useCallback(function () {
        var checkedRows = {};
        // if check all is not check, we check all
        if (!allChecked && rowsData) {
            rowsData.forEach(function (row) {
                checkedRows[row.id] = true;
            });
        }
        handleUxChange === null || handleUxChange === void 0 ? void 0 : handleUxChange('checkedRows', checkedRows);
    }, [handleUxChange, rowsData, allChecked]);
    return [!!allChecked, toggleAllHandler];
};
